import { toast } from "react-toastify";

import { INPUT_TYPE } from "../constants";
import { CREATE_EXPENSE_CONFIGS_WITHOUT_BULK } from "../configs/createNovelConfig";

export const getUserJwtToken = (user) => {
  if (!user) return null;
  return user.getSignInUserSession().getIdToken().getJwtToken();
};

export function setLocalStorageItem(key, item) {
  localStorage.setItem(key, JSON.stringify(item));
}

export function getLocalStorageItem(key) {
  const item = localStorage.getItem(key);
  if (item) {
    try {
      return JSON.parse(item);
    } catch (err) {
      console.log(err.message);
    }
  }
  return null;
}

export function generateRandomId() {
  return Math.random().toString(36).slice(2);
}

export function getTimeSinceDate(date) {
  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years ago";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months ago";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days ago";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours ago";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes ago";
  }
  return Math.floor(seconds) + " seconds ago";
}

export function get2DigitNumber(sum) {
  return Math.round(sum * 100) / 100;
}

export const dubugTest = () => {
  // const intervalId = setInterval(() => {
  //   debugger;
  // }, 10);
  // return () => {
  //   clearInterval(intervalId);
  // };
};

export function handleAPICallError({ callback = () => {}, err = {} }) {
  console.error("Error:", err);
  var errorMsg = err;
  if (err.message) {
    errorMsg = err.message;
  } else if (err.response?.data) {
    errorMsg = err.response.data;
  }
  const { code, message, response: { data, status } = {} } = err;
  var returnErr = errorMsg;
  if (typeof data == "object") {
    if (data.message) returnErr = `Error ${status}: ${data.message}`;
  }
  if (!returnErr && code && message) {
    returnErr = `${code}: ${message}`;
  }
  if (status === 429) {
    returnErr = "Too many requests maded, please try again later or contact support@kokofin.com if problem persists.";
  }
  toast.error(returnErr);
  callback({ err: returnErr });
}

export function isValidEmail(email) {
  // Regular expression to check the email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function isValidNumber(value) {
  return !Number.isNaN(Number(value));
}

export function delay(seconds) {
  return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
}

export function redirectLogin() {
  const currentPage = window.location.pathname + window.location.search;
  window.location.href = `/login?redirect=${encodeURIComponent(currentPage)}`;
}
function findListWithMostItems(input) {
  // Define all comma variants as a regex character class
  const commaRegex = /[,，、،]/;

  // Optional: if input contains multiple lines or sentences separated by other things,
  // split by line breaks or semicolons first
  const blocks = input.split(/[\n;]/);

  let maxList = [];
  for (const block of blocks) {
    const items = block
      .split(commaRegex)
      .map((item) => item.trim())
      .filter(Boolean);
    if (items.length > maxList.length) {
      maxList = items;
    }
  }

  return maxList;
}

export function getCustomFieldsFromProfile(userProfile) {
  const { fieldConfigs = [] } = userProfile || {};
  return fieldConfigs.map((item) => {
    if (item.inputType === INPUT_TYPE.SELECT) {
      const { enumValues } = item;
      var enumValues2 = findListWithMostItems(enumValues);
      return {
        ...item,
        enumValues: enumValues2.map((item) => ({
          name: item.trim(),
          value: item.trim(),
        })),
      };
    }
    return item;
  });
}
export function getExpenseFieldsFromProfile(userProfile) {
  const { fieldConfigs = [] } = userProfile || {};
  return [
    ...CREATE_EXPENSE_CONFIGS_WITHOUT_BULK,
    ...fieldConfigs.map((item) => {
      if (item.inputType === INPUT_TYPE.SELECT) {
        const { enumValues } = item;
        var enumValues2 = findListWithMostItems(enumValues);
        return {
          ...item,
          enumValues: enumValues2.map((item) => ({
            name: item.trim(),
            value: item.trim(),
          })),
        };
      }
      return item;
    }),
  ];
}

export function generateColors(length) {
  const colors = [];
  const saturation = 65; // Balanced saturation for pleasant colors
  const lightness = 65; // Light enough for good contrast
  const hueStep = 360 / length;

  const hslToHex = (h, s, l) => {
    h /= 360;
    s /= 100;
    l /= 100;
    let r, g, b;
    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      const hue2rgb = (p, q, t) => {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      };
      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    const toHex = (x) => {
      const hex = Math.round(x * 255)
        .toString(16)
        .toUpperCase();
      return hex.length === 1 ? "0" + hex : hex;
    };
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  };

  // Start at 30° (orange) instead of 0° (red) for softer start
  let baseHue = 30;
  for (let i = 0; i < length; i++) {
    const hue = (baseHue + i * hueStep) % 360;
    colors.push(hslToHex(hue, saturation, lightness));
  }
  return colors;
}

/**
 * Generates a list of mock expense data objects for a given month.
 *
 * @param {number} numEntries - The number of mock data entries to generate.
 * @param {number} [month=new Date().getMonth()] - Month index (0 for January, 11 for December). Defaults to current month.
 * @param {number} [year=new Date().getFullYear()] - Year of the data. Defaults to current year.
 * @returns {Array<Object>} Array of expense data objects.
 */
export function generateMonthlyMockData(numEntries, month = new Date().getMonth(), year = new Date().getFullYear()) {
  const categories = [
    "Grocery",
    "Transport",
    "Utility",
    "Online Shopping",
    "Clothes",
    "Entertainment",
    "Daily",
    "Other",
    "Drinks",
    "Restaurant",
    "Social",
  ];

  const data = [];

  for (let i = 0; i < numEntries; i++) {
    // Randomly select a day in the month (using up to 28 to ensure validity across all months)
    const day = Math.floor(Math.random() * 28) + 1;
    const purchasedDateObj = new Date(year, month, day);
    const purchasedDate = purchasedDateObj.toISOString().split("T")[0]; // Format: YYYY-MM-DD

    // Random category from the list
    const category = categories[Math.floor(Math.random() * categories.length)];

    // Create a new expense object matching the given structure
    const expense = {
      expenseId: `MOCK_ID_${i + 1}`,
      category,
      createdDate: new Date().toISOString(),
      description: "",
      lastModifiedDate: new Date().toISOString(),
      purchasedDate,
      title: `${category} Expense ${i + 1}`,
      total: (Math.random() * 100).toFixed(2), // Random total up to 100; adjust as needed
      userId: "69c4856b-fa22-6881-1a2a-036b258cbcea",
      version: 1,
    };

    data.push(expense);
  }

  return data;
}

export function findMissingKeys(source, target, path = "") {
  const missing = {};

  for (const key in source) {
    const fullPath = path ? `${path}.${key}` : key;

    if (!(key in target)) {
      missing[key] = source[key]; // Copy entire subtree if not present
    } else if (
      typeof source[key] === "object" &&
      source[key] !== null &&
      typeof target[key] === "object" &&
      target[key] !== null
    ) {
      const nestedMissing = findMissingKeys(source[key], target[key], fullPath);
      if (Object.keys(nestedMissing).length > 0) {
        missing[key] = nestedMissing;
      }
    }
  }

  return missing;
}

export const createDefaultHeaderMapping = (headers, fieldConfigs) => {
  const keywordFieldMapping = {
    purchasedDate: ["date", "purchase date", "bought", "transaction date"],
    title: ["title", "name", "item", "product"],
    description: ["description", "details", "desc", "info"],
    total: ["total", "amount", "price", "cost", "sum"],
    category: ["category", "categories"],
  };
  const hmap = {};

  for (const h of headers) {
    const lowerHeader = h.toLowerCase();

    let matchedField = "";
    for (const [fieldName, keywords] of Object.entries(keywordFieldMapping)) {
      if (keywords.some((keyword) => lowerHeader.includes(keyword))) {
        matchedField = fieldName;
        break;
      }
    }

    hmap[h] = matchedField;
  }

  return hmap;
};

export function getNumberFromStr(str) {
  const numbersWithDecimal = str.match(/[\d.]+/g)?.join("") || "";
  return numbersWithDecimal;
}
